const DEFAULT_PUBLIC_BASE_URL = 'https://grownupscalendar.com';

export function getPublicBaseUrl() {
  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return origin;
    }
  }
  return DEFAULT_PUBLIC_BASE_URL;
}

export function getEventPath(event) {
  if (event?.visibility === 'public' && event?.slug) {
    return `/events/${event.slug}`;
  }
  if (event?.visibility === 'invite-only' && event?.inviteToken) {
    return `/events/invite/${event.inviteToken}`;
  }
  return null;
}

export function getEventUrl(event, baseUrl = getPublicBaseUrl()) {
  const path = getEventPath(event);
  if (!path) return null;
  return `${baseUrl}${path}`;
}

export function getEventDisplayUrl(event) {
  const path = getEventPath(event);
  if (!path) return null;
  const withoutHttps = DEFAULT_PUBLIC_BASE_URL.replace('https://', '');
  const withoutHttp = withoutHttps.replace('http://', '');
  return `${withoutHttp}${path}`;
}
